import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, showNotification, refreshView as refreshViewAction } from 'react-admin';

import request from '../../../../network/request';
import resourceConfig from './config';

class SetAsDefaultButton extends Component {
    state = {
      executing: false
    }
    handleClick = async() => {
        const { showNotification, record, refreshView } = this.props;

        this.setState({
          executing: true
        });
    
        let data = {
          id: record.id
        }
    
        let response = null;
        try {
          response = await request({
            apiService: 'account',
            method: 'POST',
            path: '/admin/pg/default',
            urlParams: data,
          });
        } catch (e) {
          console.error(e);
        }
        if (response === null || !response.ok) {
          showNotification(`resources.${resourceConfig.name}.setAsDefault.errorMessage`, 'error');
        } else {
          showNotification(`resources.${resourceConfig.name}.setAsDefault.successMessage`, 'success');
        }
        
        this.setState({
          executing: false
        }, refreshView);
    };
    

    render() {
        return (
            <Button label={`resources.${resourceConfig.name}.setAsDefault.action`} disabled={this.state.executing} onClick={this.handleClick} />
        );
    }
}

export default connect(undefined, { 
  showNotification, 
  refreshView: refreshViewAction 
})(SetAsDefaultButton);